import React, { useState, useEffect } from "react";

function NumberInput(props) {
    const [numberValue, setNumberValue] = useState(props.value || 0);

    const increaseValue = () => {
        if (!props.disabled) {
            let val = Number(numberValue) + 1;
            setNumberValue(val);
            props.handleInput({
                target: {
                    id: props.id,
                    value: val,
                }
            });
        }
    };

    const decreaseValue = () => {
        if (!props.disabled) {
            if (numberValue > 0) {
                let val = numberValue - 1;
                setNumberValue(val);
                props.handleInput({
                    target: {
                        id: props.id,
                        value: val,
                    }
                });
            }
        }
    };

    useEffect(() => {
        setNumberValue(props.value || 0)
    }, [props])
    

    return (
        <div className="mb-3">
            {props.label ? (<label  className="form-label ">{props.label}</label>) : ("")}
            <div id={props.id} className={`number-input-container ${numberValue > 0 ? 'number-input-selected' : ''}`}>
                <div style={{ cursor: 'pointer' }} onClick={decreaseValue} >
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="1" viewBox="0 0 13 1" fill="none" >
                        <rect x="0.370117" y="0.945587" width="0.857143" height="12" transform="rotate(-90 0.370117 0.945587)" fill="#005E2C" />
                    </svg>
                </div>
                <span className="input-order">{numberValue}</span>
                <div style={{ cursor: 'pointer' }} onClick={increaseValue}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <rect x="5.94189" y="0.598419" width="0.857143" height="12" fill="#005E2C" />
                        <rect x="0.370117" y="7.02699" width="0.857143" height="12" transform="rotate(-90 0.370117 7.02699)" fill="#005E2C" />
                    </svg>
                </div>
            </div>
        </div>
    );
}

export default NumberInput;
